<template>
  <b-form-group
    label="Vade Tarihi"
    label-for="expiry_date"
  >
    <validation-provider
      #default="{ errors }"
      name="Vade Tarihi"
      rules="required"
    >
      <b-form-datepicker
        id="expiry_date"
        v-model="dataItem.expiry_date"
        v-bind="{labelNoDateSelected: 'Vade Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Title',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['promissories/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
